import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AssessmentMatch } from "../../../model/assessment";
import { ASSESSMENT_MATCH_STORE_STATE } from "../../../shared/enums";

const initialState: {
  activeMatch: AssessmentMatch | null;
  activeMatches: AssessmentMatch[];
  matches: AssessmentMatch[];
  pending: boolean;
  error: { value: boolean; message?: string; code?: string };
  state: ASSESSMENT_MATCH_STORE_STATE;
  isValidating: boolean;
} = {
  activeMatch: null,
  activeMatches: [],
  pending: false,
  error: { value: false, message: "" },
  state: ASSESSMENT_MATCH_STORE_STATE.fetching,
  matches: [],
  isValidating: false,
};

export const userAssessmentMatchStore = createSlice({
  name: "assessmentMatch",
  initialState,
  reducers: {
    assessmentMatch(state) {
      return {
        ...state,
        pending: true,
        error: { value: false },
        state: ASSESSMENT_MATCH_STORE_STATE.fetching,
      };
    },
    setActiveAssessmentMatch(
      state,
      action: PayloadAction<AssessmentMatch | null>
    ) {
      return {
        ...state,
        activeMatch: action.payload,
        pending: false,
        state: ASSESSMENT_MATCH_STORE_STATE.fetchSuccess,
      };
    },
    setActiveAssessmentMatches(
      state,
      action: PayloadAction<AssessmentMatch[]>
    ) {
      return {
        ...state,
        activeMatches: action.payload,
        pending: false,
        state: ASSESSMENT_MATCH_STORE_STATE.fetchSuccess,
      };
    },
    setAssessmentMatches(state, action: PayloadAction<AssessmentMatch[]>) {
      return {
        ...state,
        matches: action.payload,
        pending: false,
        state: ASSESSMENT_MATCH_STORE_STATE.fetchMatchesSuccess,
      };
    },
    assessmentMatchFail(state) {
      return {
        ...state,
        pending: false,
        error: { value: true },
        state: ASSESSMENT_MATCH_STORE_STATE.fetchFail,
      };
    },
    assessmentMatchStartClose(state) {
      return {
        ...state,
        pending: true,
        error: { value: false },
        state: ASSESSMENT_MATCH_STORE_STATE.closing,
      };
    },
    assessmentMatchCloseFail(
      state,
      action: PayloadAction<undefined | { message: string; error?: string }>
    ) {
      return {
        ...state,
        pending: false,
        error: { value: true, ...(action.payload || {}) },
        state: ASSESSMENT_MATCH_STORE_STATE.closeFail,
      };
    },
    assessmentMatchCloseSuccess(state) {
      return {
        ...state,
        activeMatch: null,
        activeMatches: [],
        pending: false,
        error: { value: false },
        state: ASSESSMENT_MATCH_STORE_STATE.closeSuccess,
        isValidating: false,
      };
    },
    assessmentMatchValidateStart(state) {
      return { ...state, isValidating: true };
    },
    assessmentMatchValidateStop(state) {
      return { ...state, isValidating: false };
    },
  },
});

export const {
  assessmentMatch,
  assessmentMatchFail,
  setActiveAssessmentMatch,
  setActiveAssessmentMatches,
  assessmentMatchStartClose,
  assessmentMatchCloseFail,
  assessmentMatchCloseSuccess,
  setAssessmentMatches,
  assessmentMatchValidateStart,
  assessmentMatchValidateStop,
} = userAssessmentMatchStore.actions;
